// client/src/lib/card.js
// Normalize raw card-input into a clean 16-digit Nedarim PAN.
//
// Handles three shapes that show up in real life:
//   1. Plain 16 digits with or without spaces/dashes
//        "1234 5678 9012 3456"  → "1234567890123456"
//   2. Magnetic-stripe Track 2 ";<18digits>=<18digits>?"
//        — Nedarim hardware sends this when a card is swiped or its
//          stripe is pasted into the field. Reconstructs the 16-digit
//          PAN via the same algorithm as src/lib/nedarimCard.js
//          (institution[7] + serial[6] + tail3 of the second block).
//   3. Anything else — strips non-digits + caps to 16. May produce
//      garbage but won't crash; the server-side hash validator catches
//      a malformed PAN at submission time.

export function parseCardInput(raw) {
  if (typeof raw !== 'string') return '';
  let s = raw.trim();
  // Strip Track-2 sentinels.
  if (s.startsWith(';')) s = s.slice(1);
  if (s.endsWith('?')) s = s.slice(0, -1);

  const track2 = s.match(/^(\d{18})=(\d{18})$/);
  if (track2) {
    const left = track2[1];
    const right = track2[2];
    const instRaw = left.slice(0, 9).replace(/^0+/, '');
    const serRaw = left.slice(9, 18).replace(/^0+/, '');
    // Same bounds check as nedarimCard.parseFromStripe — if either
    // overflows we fall through to the plain digit-strip path rather
    // than returning a malformed PAN.
    if (instRaw.length <= 7 && serRaw.length <= 6) {
      return (
        instRaw.padStart(7, '0') +
        serRaw.padStart(6, '0') +
        right.slice(-3)
      );
    }
  }

  return s.replace(/\D/g, '').slice(0, 16);
}
